// removed by extract-text-webpack-plugin
module.exports = {"Avatar":"Avatar__Avatar__3JpRS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Avatar/Avatar.css
// module id = 82
// module chunks = 0